import axios from 'axios'

import { isTokenExpired } from '../utils/helpers'
import {
  getInvestorDataFromSS,
  removeInvestorDataFromLS,
  removeInvestorDataFromSS,
} from '../lib/utils/local-storage'

axios.interceptors.request.use(
  async (config) => {
    const { authToken: token } = getInvestorDataFromSS()

    if (token && isTokenExpired(token)) {
      removeInvestorDataFromLS()
      removeInvestorDataFromSS()
      window.location.href = '/home/session-expired'
    } else if (token) config.headers = { ...config.headers, Authorization: `${token}` }

    return config
  },
  (error) => Promise.reject(error),
)

axios.interceptors.response.use(
  (response) => {
    if (!response.data.error) return response
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const axiosInstance = axios

export { userServices } from './user-service'
export { projectServices } from './project-service'
export { kycServices } from './kyc-service'
export { investServices } from './invest-service'
export { homeServices } from './home-service'
export { documentServices } from './document-service'
export { dashboardServices } from './dashboard-service'
export { portfolioStatementsServices } from './portfolio-statements-service'
export type { PortfolioStatement } from './portfolio-statements-service'
export { withdrawalServices } from './withdrawal-service'
export { opportunityServices } from './opportunity-service'
export { sanityServices } from './sanity-service'
export { contactsServices } from './contact-us-service'
export { default as intercomService } from './intercom-service'
export { comingSoonServices } from './coming-soon-service'
export { faqServices } from './faq-service'
export { whatsAppService } from './whatsapp-support'
export { secondaryMarketServices } from './secondary-market-service'
export { walletServices } from './wallet-service'
export {
  partnerServices,
  getPartnerApiError,
  getPartnerErrorMessage,
  PARTNER_INVESTOR_PAGE_SIZE,
} from './partner-service'
export { tradingServices } from './trading-service'
